export default "__VITE_ASSET__B38eVD_9__"